var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-format',{attrs:{"date":_vm.date,"past-class":_vm.pastClass}})
}
var staticRenderFns = []

export { render, staticRenderFns }